import React, { Component } from 'react'
import { Field } from 'redux-form'
import { Input } from 'components/Input/Input'
import Button from 'components/Button'
import { vRequired, vEmail, vMaxLength, vMinLength } from 'components/Input/Input.validations'

import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'
import sMarg from 'styles/modules/margins.scss'
import sText from 'components/Text/Text.scss'

const vAbnMinLength = vMinLength(11)
const vAbnMaxLength = vMaxLength(11)

export default class BillingAccountFormEssentialStep extends Component {
  render() {
    const { loading, prev, invalid, isEdit } = this.props

    return (
      <div>
        <div className={cn(sText.descrip1, sMarg.mb30)}>1. Basic details</div>

        <Field
          name="customer"
          label="Company Name"
          component={Input}
          validate={[vRequired]}
          disabled={isEdit}
        />
        <Field
          name="abn"
          label="ABN"
          component={Input}
          validate={isEdit ? [] : [vRequired, vAbnMinLength, vAbnMaxLength]}
          disabled={isEdit}
        />
        <Field
          name="invoiceDelivery"
          label="Billing Email"
          component={Input}
          validate={[vRequired, vEmail]}
        />

        {prev && (
          <div
            className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
            style={{ marginTop: '40px' }}
          >
            <Button color="tertiary" type="submit" loading={loading} disabled={invalid || loading}>
              Next
            </Button>
            <br />
            <br />
            <Button plain onClick={prev}>
              Cancel
            </Button>
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/BillingAccountFormEssentialStep/BillingAccountFormEssentialStep.jsx